export let Code = {
type: `@Component({
    selector: 'p-sidebar',
    template:
        <p-sidebar [(visible)]="visibleSidebar1" [baseZIndex]="10000">
            <h1 style="font-weight:normal;display: block;">Left Sidebar</h1>
            <button pButton type="button" (click)="visibleSidebar1 = false" label="Save" class="ui-button-success"></button>
            <button pButton type="button" (click)="visibleSidebar1 = false" label="Cancel" class="ui-button-secondary"></button>
        </p-sidebar>

        <p-sidebar [(visible)]="visibleSidebar2" position="right" [baseZIndex]="10000">
            <h1 style="font-weight:normal;display: block;">Right Sidebar</h1>
            <button pButton type="button" (click)="visibleSidebar2 = false" label="Save" class="ui-button-success"></button>
            <button pButton type="button" (click)="visibleSidebar2 = false" label="Cancel" class="ui-button-secondary"></button>
        </p-sidebar>

        <p-sidebar [(visible)]="visibleSidebar3" position="top" [baseZIndex]="10000">
            <h1 style="font-weight:normal;display: block;">Top Sidebar</h1>
            <button pButton type="button" (click)="visibleSidebar3 = false" label="Save" class="ui-button-success"></button>
            <button pButton type="button" (click)="visibleSidebar3 = false" label="Cancel" class="ui-button-secondary"></button>
        </p-sidebar>

        <p-sidebar [(visible)]="visibleSidebar4" position="bottom" [baseZIndex]="10000">
            <h1 style="font-weight:normal;display: block;">Bottom Sidebar</h1>
            <button pButton type="button" (click)="visibleSidebar4 = false" label="Save" class="ui-button-success"></button>
            <button pButton type="button" (click)="visibleSidebar4 = false" label="Cancel" class="ui-button-secondary"></button>
        </p-sidebar>

        <p-sidebar [(visible)]="visibleSidebar5" [fullScreen]="true" [baseZIndex]="10000">
            <h1 style="font-weight:normal;display: block;">Full Screen Sidebar</h1>
            <button pButton type="button" (click)="visibleSidebar5 = false" label="Save" class="ui-button-success"></button>
            <button pButton type="button" (click)="visibleSidebar5 = false" label="Cancel" class="ui-button-secondary"></button>
        </p-sidebar>

        <button pButton type="button" (click)="visibleSidebar1 = true" icon="ion-android-arrow-forward"></button>
        <button pButton type="button" (click)="visibleSidebar2 = true" icon="ion-android-arrow-back"></button>
        <button pButton type="button" (click)="visibleSidebar3 = true" icon="ion-android-arrow-down"></button>
        <button pButton type="button" (click)="visibleSidebar4 = true" icon="ion-android-arrow-up"></button>
        <button pButton type="button" (click)="visibleSidebar5 = true" icon="ion-android-expand"></button>
})
export class Sidebar {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/sidebar.ts